const ChangellyCurrencies = {
  ABYSS: { symbol: 'ABYSS', name: 'The Abyss', fixRateEnabled: false },
  ADX: { symbol: 'ADX', name: 'AdEx', fixRateEnabled: true },
  AE: { symbol: 'AE', name: 'Aeternity', fixRateEnabled: true },
  ANT: { symbol: 'ANT', name: 'Aragon', fixRateEnabled: true },
  ARN: { symbol: 'ARN', name: 'Aeron', fixRateEnabled: true },
  BAT: { symbol: 'BAT', name: 'Basic Attention Token', fixRateEnabled: true },
  BETR: { symbol: 'BETR', name: 'BetterBetting', fixRateEnabled: false },
  BNB: { symbol: 'BNB', name: 'Binance token', fixRateEnabled: true },
  BNT: { symbol: 'BNT', name: 'Bancor Network Token', fixRateEnabled: true },
  BQX: { symbol: 'BQX', name: 'ETHOS', fixRateEnabled: true },
  BRD: { symbol: 'BRD', name: 'Bread', fixRateEnabled: true },
  CVC: { symbol: 'CVC', name: 'Civic', fixRateEnabled: true },
  DAI: { symbol: 'DAI', name: 'Dai', fixRateEnabled: true },
  DCN: { symbol: 'DCN', name: 'Dentacoin', fixRateEnabled: false },
  DENT: { symbol: 'DENT', name: 'Dent', fixRateEnabled: true },
  DGD: { symbol: 'DGD', name: 'DigixDAO', fixRateEnabled: true },
  DGTX: { symbol: 'DGTX', name: 'Digitex Futures', fixRateEnabled: false },
  DNT: { symbol: 'DNT', name: 'district0x', fixRateEnabled: true },
  EDG: { symbol: 'EDG', name: 'Edgeless', fixRateEnabled: true },
  ENJ: { symbol: 'ENJ', name: 'Enjin', fixRateEnabled: true },
  EURS: { symbol: 'EURS', name: 'STASIS EURS', fixRateEnabled: false },
  FET: { symbol: 'FET', name: 'Fetch', fixRateEnabled: false },
  FUN: { symbol: 'FUN', name: 'FunFair', fixRateEnabled: true },
  GNO: { symbol: 'GNO', name: 'Gnosis', fixRateEnabled: false },
  GNT: { symbol: 'GNT', name: 'Golem', fixRateEnabled: true },
  GUP: { symbol: 'GUP', name: 'Guppy', fixRateEnabled: true },
  GUSD: { symbol: 'GUSD', name: 'Gemini Dollar', fixRateEnabled: true },
  HMQ: { symbol: 'HMQ', name: 'Humaniq', fixRateEnabled: true },
  HT: { symbol: 'HT', name: 'Huobi token', fixRateEnabled: false },
  KNC: { symbol: 'KNC', name: 'Kyber Network', fixRateEnabled: true },
  LINK: { symbol: 'LINK', name: 'Link', fixRateEnabled: true },
  LRC: { symbol: 'LRC', name: 'Loopring', fixRateEnabled: true },
  LUN: { symbol: 'LUN', name: 'Lunyr', fixRateEnabled: true },
  MANA: { symbol: 'MANA', name: 'Decentraland', fixRateEnabled: true },
  MCO: { symbol: 'MCO', name: 'Monaco', fixRateEnabled: true },
  MITH: { symbol: 'MITH', name: 'Mithril', fixRateEnabled: true },
  MKR: { symbol: 'MKR', name: 'Maker', fixRateEnabled: true },
  NEXO: { symbol: 'NEXO', name: 'NEXO', fixRateEnabled: true },
  NGC: { symbol: 'NGC', name: 'NAGA Coin', fixRateEnabled: false },
  NOAH: { symbol: 'NOAH', name: 'Noah', fixRateEnabled: true },
  OMG: { symbol: 'OMG', name: 'OmiseGo', fixRateEnabled: true },
  PAX: { symbol: 'PAX', name: 'Paxos Standard Token', fixRateEnabled: true },
  PAY: { symbol: 'PAY', name: 'TenXPay', fixRateEnabled: true },
  PMA: { symbol: 'PMA', name: 'PumaPay', fixRateEnabled: true },
  POLY: { symbol: 'POLY', name: 'Polymath', fixRateEnabled: true },
  POWR: { symbol: 'POWR', name: 'Power Ledger', fixRateEnabled: true },
  PPT: { symbol: 'PPT', name: 'Populous', fixRateEnabled: true },
  PTOY: { symbol: 'PTOY', name: 'Patientory', fixRateEnabled: false },
  R: { symbol: 'R', name: 'Revain', fixRateEnabled: false },
  RCN: { symbol: 'RCN', name: 'Ripio Credit Network', fixRateEnabled: true },
  REP: { symbol: 'REP', name: 'Augur', fixRateEnabled: true },
  RLC: { symbol: 'RLC', name: 'iExec RLC', fixRateEnabled: true },
  SALT: { symbol: 'SALT', name: 'Salt', fixRateEnabled: false },
  SNM: { symbol: 'SNM', name: 'SONM', fixRateEnabled: true },
  STORJ: { symbol: 'STORJ', name: 'Storj', fixRateEnabled: true },
  STORM: { symbol: 'STORM', name: 'Storm', fixRateEnabled: true },
  STX: { symbol: 'STX', name: 'Stox', fixRateEnabled: false },
  SWT: { symbol: 'SWT', name: 'Swarm City', fixRateEnabled: false },
  TEL: { symbol: 'TEL', name: 'Telcoin', fixRateEnabled: false },
  TRST: { symbol: 'TRST', name: 'Trustcoin', fixRateEnabled: false },
  TUSD: { symbol: 'TUSD', name: 'TrueUSD', fixRateEnabled: true },
  USDC: { symbol: 'USDC', name: 'USD coin', fixRateEnabled: true },
  VIB: { symbol: 'VIB', name: 'Viberate', fixRateEnabled: true },
  WAX: { symbol: 'WAX', name: 'WAX token', fixRateEnabled: true },
  WINGS: { symbol: 'WINGS', name: 'Wings DAO', fixRateEnabled: true },
  WTC: { symbol: 'WTC', name: 'Waltonchain', fixRateEnabled: true },
  ZAP: { symbol: 'ZAP', name: 'Zap', fixRateEnabled: false },
  ZRX: { symbol: 'ZRX', name: '0x Protocol Token', fixRateEnabled: true },
  ADA: { symbol: 'ADA', name: 'Cardano', fixRateEnabled: true },
  ARK: { symbol: 'ARK', name: 'Ark', fixRateEnabled: true },
  BCD: { symbol: 'BCD', name: 'Bitcoin Diamond', fixRateEnabled: true },
  BCHABC: { symbol: 'BCHABC', name: 'Bitcoin Cash ABC', fixRateEnabled: true },
  BCHSV: { symbol: 'BCHSV', name: 'Bitcoin Cash SV', fixRateEnabled: true },
  BTC: { symbol: 'BTC', name: 'Bitcoin', fixRateEnabled: true },
  BTG: { symbol: 'BTG', name: 'Bitcoin Gold', fixRateEnabled: true },
  BTT: { symbol: 'BTT', name: 'BitTorrent', fixRateEnabled: true },
  DASH: { symbol: 'DASH', name: 'Dash', fixRateEnabled: true },
  DCR: { symbol: 'DCR', name: 'Decred', fixRateEnabled: true },
  DGB: { symbol: 'DGB', name: 'DigiByte', fixRateEnabled: true },
  DOGE: { symbol: 'DOGE', name: 'Dogecoin', fixRateEnabled: true },
  ETC: { symbol: 'ETC', name: 'Ethereum Classic', fixRateEnabled: true },
  ETH: { symbol: 'ETH', name: 'Ethereum', fixRateEnabled: true },
  GAS: { symbol: 'GAS', name: 'Gas', fixRateEnabled: false },
  GRS: { symbol: 'GRS', name: 'Groestlcoin', fixRateEnabled: true },
  KMD: { symbol: 'KMD', name: 'Komodo', fixRateEnabled: false },
  LSK: { symbol: 'LSK', name: 'Lisk', fixRateEnabled: true },
  LTC: { symbol: 'LTC', name: 'Litecoin', fixRateEnabled: true },
  MAID: { symbol: 'MAID', name: 'MaidSafeCoin', fixRateEnabled: true },
  NAV: { symbol: 'NAV', name: 'NAV Coin', fixRateEnabled: true },
  NEO: { symbol: 'NEO', name: 'Neo', fixRateEnabled: true },
  NIM: { symbol: 'NIM', name: 'Nimiq', fixRateEnabled: false },
  ONT: { symbol: 'ONT', name: 'Ontology', fixRateEnabled: true },
  QTUM: { symbol: 'QTUM', name: 'Qtum Ignition', fixRateEnabled: true },
  SMART: { symbol: 'SMART', name: 'SmartCash', fixRateEnabled: false },
  STRAT: { symbol: 'STRAT', name: 'Stratis', fixRateEnabled: true },
  TRX: { symbol: 'TRX', name: 'Tron', fixRateEnabled: true },
  USDT: { symbol: 'USDT', name: 'Tether USD', fixRateEnabled: true },
  WAVES: { symbol: 'WAVES', name: 'Waves', fixRateEnabled: true },
  XTZ: { symbol: 'XTZ', name: 'Tezos', fixRateEnabled: true },
  XVG: { symbol: 'XVG', name: 'Verge', fixRateEnabled: true },
  XZC: { symbol: 'XZC', name: 'ZCoin', fixRateEnabled: true },
  ZEC: { symbol: 'ZEC', name: 'Zcash', fixRateEnabled: true },
  ZEN: { symbol: 'ZEN', name: 'Horizen', fixRateEnabled: true }
};
export { ChangellyCurrencies };
